<template>
    <div id="app">
        <!-- Header -->
        <div v-if="!$store.init">
            <Header/>
        </div>
        <!-- Main -->
        <div>
            <b-container style="max-width:850px">
                <b-container fluid="sm">

                    <!-- Affichera le Stepper dès lors qu'une valeur de step non null sera envoyée -->
                    <Stepper
                        v-if="step"
                        :step="step"
                        :state="state"
                        :isFirstVisit="isFirstVisit"/>

                    <transition name="router-fade" mode="out-in">
                        <!-- Charge les composant a travers router, et appel setStepper pour mise à jour de du Stepper a la bonne étape -->
                        <router-view @onSetStepper="setStepper" />
                    </transition>
                </b-container>
            </b-container>
        </div>
        <!-- Footer -->
        <div v-if="!$store.init">
            <hr class="mt-5 mb-3"/>
            <b-container style="max-width:850px">
                <b-container fluid="sm">
                    <Footer/>
                </b-container>
            </b-container>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header'
import Stepper from '@/components/Stepper'
import Footer from '@/components/Footer'

export default {
    name: 'App',
    components: {
        Header,
        Stepper,
        Footer
    },
    data() {
        return {
            step: null,
            state: null,
            isFirstVisit: null
        }
    },
    methods: {
        setStepper(val) {
            this.step = val
            this.state = { visited: true, actived: true }
            // S'appuie sur la valeur visited du step, pour définir si l'appel de cette step sera la toute première visite ou pas (pour déclencher la line animée)
            this.isFirstVisit = this.$actions.getStepper(val) ? !this.$actions.getStepper(val).visited : null;
        }
    }
}
</script>

<style>
/** Apparition de l'ascensseur à cause du comportement du forçage de la largeur/hauteur à 100% du viewport : 100vw, 100vh (voir classe #app) */
html, body {
    overflow-x: hidden;
    background-color: #FAFAFA;
}

/** Défini (hors header) la taille max de la largeur des pages : NE FONCTIONNE PAS APRES LE BUILD ?? */
/* .max-width {
    max-width: 850px;
} */

/** Applique un style basé sur grid à l'élément racine app, afin de pouvoir disposer correctement le header, main, et footer tout en bas de la page  */
#app {
    /* width: 100vw; */
    height: 100vh;
    display: grid;
    grid-template-rows: auto 1fr auto;
}

/** CSS utiles aux effets de transition du router */
.router-fade-enter-active,
.router-fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
}

.router-fade-enter,
.router-fade-leave-active {
    opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/App.vue